import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

export const applicationSettingsOverridesChanged: (mailboxInfo?: MailboxInfo) => {
    mailboxInfo: MailboxInfo | undefined;
} = action('APPLICATION_SETTINGS_OVERRIDES_CHANGED', (mailboxInfo?: MailboxInfo) => ({
    mailboxInfo,
}));
